module.exports = __webpack_public_path__ + "assets/img/3213.00b6768c.png";